<template>
  <HomePage />
</template>

<script>
import HomePage from '@/components/pages/HomePage.vue';

export default {
  name: 'HomeView',
  components: {
    HomePage,
  },
};
</script>
